export class AssignDriverScreenFiltersDataModel {
    selectedVehicleType: String = '';
    selectedParkingLocation: String = '';
    selectedQueueLocation: String = '';
    selectedDriverType: any = '';
    requestedSortKey: any = '';
    selectedGroup: any = '';
    selectedDispatchAddress: any = '';

    constructor(options?: {
        selectedVehicleType: String;
        selectedParkingLocation: String;
        selectedQueueLocation: String;
        selectedDriverType: String;
        requestedSortKey: String;
        selectedGroup?: any;
        selectedDispatchAddress: any;
    }) {
        if (options) {
            this.selectedVehicleType = options.selectedVehicleType;
            this.selectedParkingLocation = options.selectedParkingLocation;
            this.selectedQueueLocation = options.selectedQueueLocation;
            this.selectedDriverType = options.selectedDriverType;
            this.requestedSortKey = options.requestedSortKey;
            this.selectedGroup = options.selectedGroup;
            this.selectedDispatchAddress = options.selectedDispatchAddress;
        }
    }
}